<div class="container-fluid p-0 id-page-container"  id="home">
  <div class="row no-gutters">
    <div class="col">
      <div class="id-content">
        <ng-content select="[content-body]"></ng-content>
      </div>
    </div>
  </div>
</div>